var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonenumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    d: "M25.5,17.6L21,13.1c-0.6-0.6-1.7-0.6-2.3,0L16,15.8l-5.6-5.6l2.7-2.7c0.3-0.3,0.5-0.7,0.5-1.1 c0-0.4-0.2-0.8-0.5-1.1L8.4,0.5c-0.6-0.6-1.7-0.6-2.3,0L3,3.6L2.9,3.7L0.5,6.1C0.2,6.4,0,6.8,0,7.3c0,0.4,0.2,0.8,0.5,1.1 l17.1,17.1c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.2,1.1-0.5l2.4-2.4l0.1-0.1l3.2-3.2C26.2,19.2,26.2,18.2,25.5,17.6z M21.2,21.9 l-2.5,2.5L1.6,7.3L4,4.9l0.1-0.1l3.2-3.2l4.7,4.7l-3.8,3.8L16,18l3.8-3.8l4.5,4.5L21.2,21.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonenumber);
export default __webpack_public_path__ + "static/media/Phonenumber.71839141b34d8ee011230123cff2f5df.svg";
export { ForwardRef as ReactComponent };